import { useEffect, useState, useMemo } from 'react';
import { HMSNotificationTypes, useHMSActions, useHMSNotifications } from '@100mslive/react-sdk';
import { MicOnIcon, VideoOnIcon } from '@100mslive/react-icons';
import { RequestDialog } from '../../primitives/DialogContent';

export const TrackBulkUnmuteModal = () => {
    const hmsActions = useHMSActions();
    const [muteNotification, setMuteNotification] = useState(null);
    const notification = useHMSNotifications([
        HMSNotificationTypes.CHANGE_MULTI_TRACK_STATE_REQUEST,
        HMSNotificationTypes.ROOM_ENDED,
        HMSNotificationTypes.REMOVED_FROM_ROOM,
    ]);

    useEffect(() => {
        switch (notification?.type) {
            case HMSNotificationTypes.REMOVED_FROM_ROOM:
            case HMSNotificationTypes.ROOM_ENDED:
                setMuteNotification(null);
                break;
            case HMSNotificationTypes.CHANGE_MULTI_TRACK_STATE_REQUEST:
                if (notification?.data.enabled) {
                    setMuteNotification(notification.data);
                }
                break;
            default:
                return;
        }
    }, [notification]);

    const trackTypeInfo = useMemo(() => {
        if (!muteNotification?.tracks || muteNotification.tracks.length === 0) {
            return null;
        }

        const hasAudio = muteNotification.tracks.some((track) => track.type === 'audio');
        const hasVideo = muteNotification.tracks.some((track) => track.type === 'video');

        if (hasAudio && hasVideo) {
            return {
                message: 'unmute your mic and switch on your camera',
                title: 'Track Unmute Request',
                Icon: MicOnIcon,
                actionText: 'Accept',
            };
        } else if (hasAudio) {
            return {
                message: 'unmute your mic',
                title: 'Unmute Requested',
                Icon: MicOnIcon,
                actionText: 'Unmute',
            };
        } else if (hasVideo) {
            return {
                message: 'switch on your camera',
                title: 'Camera On Requested',
                Icon: VideoOnIcon,
                actionText: 'Turn On',
            };
        }

        return null;
    }, [muteNotification?.tracks]);

    if (!muteNotification || !trackTypeInfo) {
        return null;
    }

    const { requestedBy: peer, tracks, enabled } = muteNotification;

    return (
        <RequestDialog
            title={trackTypeInfo.title}
            body={`${peer?.name} requested you to ${trackTypeInfo.message}.`}
            onOpenChange={(value) => !value && setMuteNotification(null)}
            onAction={() => {
                tracks.forEach((track) => {
                    hmsActions.setEnabledTrack(track.id, enabled);
                });
                setMuteNotification(null);
            }}
            Icon={trackTypeInfo.Icon}
            actionText={trackTypeInfo.actionText}
        />
    );
};
